import { createWebcom, Theme } from "@repo/edtech-shared";

import { EdtechCourseCompletion } from "./index";
import { WEBCOM_NAME } from "./webcom-constants";

import "@repo/edtech-styles/fonts/als-haus";
import "@repo/edtech-styles/tokens";

createWebcom<typeof EdtechCourseCompletion>({
  name: WEBCOM_NAME,
  Component: EdtechCourseCompletion,
  scopeId: `${WEBCOM_NAME}-scope`,
  attributes: [
    { name: "token", type: "string" },
    {
      name: "theme",
      type: "string",
      default: Theme.Light,
    },
    { name: "inheritBackground", type: "boolean" },
    {
      name: "inherit-theme",
      prop: "inheritTheme",
      type: "string",
    },
    { name: "noIndent", type: "boolean" },
    { name: "hideRating", type: "boolean" },
    { name: "publicationId", type: "string" },
    { name: "unitId", type: "string" },
    { name: "backButtonPath", type: "string" },
    {
      name: "isAutomaticFinishLesson",
      type: "boolean",
      default: true,
    },
  ],
});
